// @flow
import Snackbar from '@material-ui/core/Snackbar';
import { makeStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import React from 'react';

const Alert = props => (<MuiAlert
    elevation = { 6 }
    variant = 'filled'
    { ...props } />);

const useStyles = makeStyles(() => {
    return {
        root: {
            width: '100%',
            '& > * + *': {
                marginTop: 8
            }
        }
    };
});

type Props = {

    /**
     * Notification object.
     */
    notification: ?Object,

    /**
     * Open notification dialog.
     */
    openNotifier: Boolean,

    /**
     * Helps in closing the dialog.
     */
    handleClose: Function,
};

// eslint-disable-next-line react/no-multi-comp
export const MaterialNotifier = ({
    notification: { alertType, description },
    openNotifier,
    handleClose
}: Props) => {
    const classes = useStyles();

    return (
        <div className = { classes.root }>
            <Snackbar
                autoHideDuration = { 6000 }
                onClose = { handleClose }
                open = { openNotifier }>
                <Alert
                    color = { alertType }
                    onClose = { handleClose }
                    severity = { alertType }
                    sx = {{ width: '100%' }}>
                    {description}
                </Alert>
            </Snackbar>
        </div>
    );
};
